export enum MY_TICKET_TYPE {
  PARTNER = 'p',
  SHARE = 's'
}

export enum MY_TICKET_STATUS {
  // unknown
  UNKNOWN = 'UNKNOWN',

  // daily
  DAILY_BEFORE_USE = 'DAILY_BEFORE_USE',
  DAILY_AFTER_USE = 'DAILY_AFTER_USE',
  DAILY_CANCELED = 'DAILY_CANCELED',
  DAILY_EXPIRED = 'DAILY_EXPIRED',
  DAILY_REFUND_REQUEST = 'DAILY_REFUND_REQUEST',
  DAILY_REFUNDED = 'DAILY_REFUNDED',

  // monthly
  MONTHLY_PAYMENT_COMPLETED = 'MONTHLY_PAYMENT_COMPLETED',
  MONTHLY_REQUEST_CHECKING = 'MONTHLY_REQUEST_CHECKING',
  MONTHLY_REQUEST_CHECKED = 'MONTHLY_REQUEST_CHECKED',
  MONTHLY_USING = 'MONTHLY_USING',
  MONTHLY_EXPIRED = 'MONTHLY_EXPIRED',
  MONTHLY_REJECTED = 'MONTHLY_REJECTED',
  MONTHLY_REJECTED_REFUNDED = 'MONTHLY_REJECTED_REFUNDED',
  MONTHLY_STOPPED = 'MONTHLY_STOPPED',
  MONTHLY_STOPPED_REFUNDED = 'MONTHLY_STOPPED_REFUNDED',
  MONTHLY_CANCELED_REFUNDED = 'MONTHLY_CANCELED_REFUNDED',

  // share
  SHARE_USING = 'SHARE_USING',
  SHARE_EXPIRED = 'SHARE_EXPIRED',
  SHARE_REFUNDED = 'SHARE_REFUNDED',

  //period
  PERIOD_BEFORE_USE = 'PERIOD_BEFORE_USE',
  PERIOD_AFTER_USE = 'PERIOD_AFTER_USE',
  PERIOD_CANCELED = 'PERIOD_CANCELED',
  PERIOD_EXPIRED = 'PERIOD_EXPIRED',
  PERIOD_REFUND_REQUEST = 'PERIOD_REFUND_REQUEST',
  PERIOD_REFUNDED = 'PERIOD_REFUNDED'
}

export enum PAYMENT_TYPE {
  BILL = 'BILL',
  NAVERBOOKING = 'NAVERBOOKING',
  NAVERPAY = 'NAVERPAY',
  CELLPHONE = 'CELLPHONE'
}

export enum REPORT_TYPE {
  ILLEGAL_PARKING_OLD = 1,
  PARKED_ELSEWHERE_OLD = 2,
  GAVE_UP_PARKING_OLD = 3,
  OTHER_OLD = 4,
  DIFFICULT_ENVIRONMENT_OLD = 5,
  LOCATION_UNKNOWN = 6,
  ILLEGAL_PARKING = 7,
  OCCUPIED_BY_SHARER = 8,
  NO_PARKING_LINE = 9,
  OTHER = 10
}

export enum CUSTOM_EXCEPTION_ERROR_CODE {
  UNAVAILABLE_VALUE = 10000
}
